<div>
  <Navbar />
  <Sidebar />
  <div class="page-wrapper">
    <div class="hero-section w-100">
      <div class="border border-secondary rounded-4 p-2">

        <!-- Header -->
        <div class="mb-4">
          <h2 class="gradient-text fw-bold">Manage: {{ role_name }}</h2>
          <p class="text-muted">Assign and manage permissions for this role</p>
        </div>

        <!-- Tabs Navigation -->
        <ul class="nav nav-tabs nav-justified mb-4" id="adminTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active w-100 fw-bold" id="permission-management-tab" data-bs-toggle="tab"
              data-bs-target="#permission-management" type="button" role="tab" aria-controls="permission-management"
              aria-selected="true">
              Role Permissions
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link w-100 fw-bold" id="user-management-tab" data-bs-toggle="tab"
              data-bs-target="#user-management" type="button" role="tab" aria-controls="user-management"
              aria-selected="false">
              Role Users
            </button>
          </li>
        </ul>

        <!-- Tabs Content -->
        <div class="tab-content p-2" id="adminTabsContent">
          <!-- PERMISSIONS TAB -->
          <div class="tab-pane fade show active" id="permission-management" role="tabpanel" aria-labelledby="permission-management-tab">

            <!-- Statistics Cards -->
            <div class="row text-center mb-3">
              <div class="col-md-4 mb-3">
                <div class="card rounded-4 shadow-sm users-card">
                  <div class="card-body">
                    <p class="card-text display-5">{{ total_assigned_count }}</p>
                    <h5 class="card-title">Total Assigned</h5>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <div class="card rounded-4 shadow-sm users-card">
                  <div class="card-body">
                    <p class="card-text display-5">{{ active_permissions_count }}</p>
                    <h5 class="card-title">Active Permission</h5>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <div class="card rounded-4 shadow-sm users-card">
                  <div class="card-body">
                    <p class="card-text display-5">{{ inactive_permissions_count }}</p>
                    <h5 class="card-title">Inactive Permission</h5>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex mb-3">
              <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center"
                      @click="open_assign_modal">
                <i class="fas fa-plus plus-icon me-1"></i> Assign Permissions
              </button>
              <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
                      @click="$router.back()">
                Back
              </button>
            </div>

            <!-- Assigned Permissions Table -->
            <div class="card table-card">
              <div class="card-body">
                <div v-if="permissions_loading" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-3 text-muted mb-0">Loading permissions...</p>
                </div>

                <div v-else class="table-responsive content-table">
                  <table id="permissions_table" class="table text-xs table-striped" data-sort="true">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Permission Name</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody class="text-start text-xs">
                      <tr v-for="(permission, index) in role_permissions" :key="permission.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                          {{ permission.name }}
                        </td>
                        <td class="description-truncate" :title="permission.description || 'No description'">
                          {{ truncate_text(permission.description || 'No description', 100) }}
                        </td>
                        <td>
                          <span :class="['badge', permission.is_active ? 'bg-success' : 'bg-danger']">
                            {{ permission.is_active ? 'Active' : 'Inactive' }}
                          </span>
                        </td>
                        <td>
                          <button class="btn btn-sm btn-danger" @click="remove_permission(permission)">
                            Remove
                          </button>
                        </td>
                      </tr>
                      <div v-if="role_permissions.length === 0" class="text-center py-5 text-muted">
                          <i class="fas fa-info-circle me-2"></i>
                          <p class="mb-0">No permissions assigned to this role yet</p>
                      </div>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>

          <!-- USERS TAB (placeholder, unchanged) -->
          <div class="tab-pane fade" id="user-management" role="tabpanel" aria-labelledby="user-management-tab">
            <!-- Statistics Cards -->
            <div class="row text-center mb-3">
              <div class="col-md-4 mb-3">
                <div class="card rounded-4 shadow-sm users-card">
                  <div class="card-body">
                    <p class="card-text display-5">{{ total_users_count }}</p>
                    <h5 class="card-title">Total Users</h5>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <div class="card rounded-4 shadow-sm users-card">
                  <div class="card-body">
                    <p class="card-text display-5">{{ active_users_count }}</p>
                    <h5 class="card-title">Active Users</h5>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <div class="card rounded-4 shadow-sm users-card">
                  <div class="card-body">
                    <p class="card-text display-5">{{ inactive_users_count }}</p>
                    <h5 class="card-title">Inactive Users</h5>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex mb-3">
              <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
                      @click="$router.back()">
                Back
              </button>
            </div>

            <div class="card table-card">
              <div class="card-body">
                <div v-if="users_loading" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-3 text-muted mb-0">Loading users...</p>
                </div>

                <div v-else class="table-responsive content-table">
                  <table id="users_table" class=" permissions_table table text-xs table-striped" data-sort="true">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Client Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody class="text-start text-xs">
                      <tr v-for="(user, index) in role_users" :key="user.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ user.first_name }}</td>
                        <td>{{ user.last_name }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.client_type }}</td>
                        <td class="d-flex gap-2">
                          <button class="btn btn-sm upload-button text-nowrap"
                                  @click="navigate_to_permissions(user)">
                            Manage Permissions
                          </button>
                          <button v-if="user.is_active" class="btn btn-sm btn-success text-nowrap action-btn-toggle" @click="deactivate_user(user)">
                            Deactivate
                          </button>
                          <button v-else class="btn btn-sm btn-danger text-nowrap action-btn-toggle" @click="activate_user(user)">
                            Activate
                          </button>
                        </td>
                      </tr>

                      <div v-if="role_users.length === 0" class="text-center py-5 text-muted">
                        <i class="fas fa-info-circle me-2"></i>
                        <p class="mb-0">No users assigned to this role yet</p>
                      </div>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Permission Details Modal -->
  <div v-if="show_details_modal" class="modal fade show d-block custom-backdrop" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable position-relative">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h5 class="modal-title gradient-text">Details for: {{ selected_permission_details?.name }}</h5>
          </div>
          <button type="button" class="btn-close" @click="close_details_modal"></button>
        </div>

        <div class="modal-body">
          <div class="mb-4">
            <h6 class="text-muted mb-3">
              <i class="fas fa-cubes me-2"></i>Main Features & Access
            </h6>
            <div v-if="selected_permission_details?.main_features_detailed && selected_permission_details.main_features_detailed.length > 0"
                 class="row g-3">
              <div v-for="(main_feature_obj, idx) in selected_permission_details.main_features_detailed"
                   :key="idx"
                   class="col-12">
                <div class="card shadow-sm">
                  <div class="card-header bg-light">
                    <h6 class="mb-0">
                      {{ main_feature_obj.name }}
                    </h6>
                  </div>
                  <div class="card-body">
                    <div v-if="main_feature_obj.sub_features && main_feature_obj.sub_features.length > 0">
                      <div class="table-responsive">
                        <table class="table table-sm table-borderless mb-0">
                          <tbody>
                            <tr v-for="(sub_feature, sf_idx) in main_feature_obj.sub_features"
                                :key="sf_idx">
                              <td>
                                <span class="small">{{ sub_feature.name }}</span>
                              </td>
                              <td>
                                <span v-if="sub_feature.crud_actions && sub_feature.crud_actions.length > 0">
                                  <span v-for="(crud, c_idx) in sub_feature.crud_actions"
                                        :key="c_idx"
                                        class="badge bg-light text-dark border me-1 small">
                                    {{ crud }}
                                  </span>
                                </span>
                                <span v-else class="text-muted small">No actions</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <p v-else class="text-muted small mb-0">No sub-features configured</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="alert alert-info">
              <i class="fas fa-info-circle me-2"></i>
              No detailed features information available for this permission.
            </div>
          </div>
        </div>

        <div class="modal-footer">
        </div>
      </div>
    </div>
  </div>

  <!-- Enhanced Assign Permissions Modal -->
  <div v-if="show_assign_modal" class="modal fade show d-block custom-backdrop" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable position-relative">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h5 class="modal-title gradient-text">Assign Permissions to: {{ role_name }}</h5>
          </div>
          <button type="button" class="btn-close" @click="close_assign_modal"></button>
        </div>

        <div class="modal-body">
          <!-- Loading State -->
          <div v-if="modal_loading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3 text-muted mb-0">Loading available permissions...</p>
          </div>

          <!-- Permissions Content -->
          <div v-else>
            <!-- Search Box -->
            <div class="mb-3">
              <input v-model="permission_search"
                     type="text"
                     class="form-control"
                     placeholder="Search permissions...">
            </div>

            <!-- Available Permissions List -->
            <div v-if="filtered_unassigned_permissions.length > 0" class="permissions-list">
              <div v-for="permission in filtered_unassigned_permissions"
                   :key="permission.id"
                   class="card mb-2 permission-card"
                   :class="{ 'border-primary': is_permission_selected(permission) }">
                <div class="card-body p-3">
                  <div class="d-flex justify-content-between align-items-start">
                    <div class="flex-grow-1 me-3">
                      <!-- Permission Header -->
                      <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
                        <h6 class="mb-0">{{ permission.name }}</h6>
                        <span v-if="permission.main_features && permission.main_features.length > 0"
                              class="p-0 mt-1 text-decoration-none"
                              @click="show_permission_details(permission)"
                              title="View full details">
                          <i class="fas fa-info-circle"></i>
                        </span>
                      </div>

                      <!-- Description -->
                      <p class="text-muted small description-truncate"
                         v-if="permission.description"
                         :title="permission.description">
                        {{ truncate_text(permission.description, 100) }}
                      </p>

                      <!-- Main Features -->
                      <div v-if="permission.main_features && permission.main_features.length > 0">
                        <div class="d-flex flex-wrap gap-1 mb-2">
                          <span class="text-muted small me-1">Includes:</span>
                          <span v-for="(feature, idx) in permission.main_features.slice(0, 3)"
                                :key="idx"
                                class="badge bg-light text-dark border small">
                            {{ feature }}
                          </span>
                          <button v-if="permission.main_features.length > 3"
                                  class="badge bg-secondary border-0 small cursor-pointer"
                                  @click="show_permission_details(permission)">
                            +{{ permission.main_features.length - 3 }} more
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Checkbox -->
                    <div class="form-check form-switch mt-1">
                      <input class="form-check-input fs-4"
                             type="checkbox"
                             :checked="is_permission_selected(permission)"
                             @change="toggle_permission_selection(permission)">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="text-center py-5 text-muted">
              <i class="fas fa-search display-4 mb-3 opacity-25"></i>
              <p class="mb-1">No permissions found</p>
              <small>Try adjusting your search criteria or all permissions are already assigned</small>
            </div>

            <!-- Selection Summary -->
            <div v-if="selected_permissions.length > 0"
                 class="alert alert-info mt-3 d-flex align-items-center justify-content-between">
              <div>
                <i class="fas fa-check-circle me-2"></i>
                <strong>{{ selected_permissions.length }}</strong> permission(s) selected
              </div>
              <button class="btn btn-sm btn-light" @click="selected_permissions = []">
                Clear
              </button>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn upload-button text-white"
                  @click="assign_selected_permissions"
                  :disabled="modal_loading || selected_permissions.length === 0">
            <span v-if="modal_loading"
                  class="spinner-border spinner-border-sm me-2"></span>
            {{ modal_loading ? 'Assigning...' : `Assign (${selected_permissions.length})` }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>